import { render, staticRenderFns } from "./SSelectSupervice.vue?vue&type=template&id=5093f9f9"
import script from "./SSelectSupervice.vue?vue&type=script&lang=js"
export * from "./SSelectSupervice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports